import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, CalendarIcon } from 'lucide-react';
export function WhoWeAre() {
  return <section className="py-20 px-4 bg-white pt-[30px] pb-[30px]" data-id="element-227">
      <div className="max-w-6xl mx-auto" data-id="element-228">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-229">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-230">
            <img src="https://cdn.magicpatterns.com/uploads/ttPJFZ4aUyNtMWivQkpBwk/7.5.24Used-0316_Profile_RW_003.jpg" alt="ASE-certified master technician using advanced diagnostic equipment" className="w-full rounded-2xl shadow-2xl shadow-black/20 object-cover aspect-[4/3]" data-id="element-231" />
          </motion.div>

          {/* Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="space-y-6" data-id="element-232">
            <span className="uppercase tracking-widest text-sm font-bold text-brand-accent block" data-id="element-233">
              Who we are
            </span>
            <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark" data-id="element-234">
              St. Paul's Toyota and Lexus shop. Since 1977.
            </h2>

            <div className="text-lg md:text-xl text-gray-700 leading-relaxed space-y-5" data-id="element-235">
              <p data-id="element-236">
                Lancer Service has been in St. Paul for nearly 50 years. Some of
                the Toyotas we see today belong to people whose parents brought
                theirs.
              </p>
              <p data-id="element-237">
                That kind of history doesn't happen by accident. It happens
                because we're honest with people — about what their car needs,
                what it doesn't, and what can wait. We're not trying to turn
                every visit into a big ticket. We're trying to be the shop you
                call first, for as long as you own your car.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2" data-id="element-238">
              <div className="flex items-center gap-3 bg-brand-light border border-gray-200 rounded-2xl p-4 shadow-sm" data-id="element-239">
                <div className="w-11 h-11 rounded-xl bg-brand-accent/15 flex items-center justify-center flex-shrink-0" data-id="element-240">
                  <CalendarIcon className="w-5 h-5 text-brand-accent" data-id="element-241" />
                </div>
                <div data-id="element-242">
                  <p className="font-heading uppercase tracking-wide text-xs font-bold text-gray-500" data-id="element-243">
                    Established
                  </p>
                  <p className="font-bold text-brand-dark" data-id="element-244">Since 1977</p>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-brand-light border border-gray-200 rounded-2xl p-4 shadow-sm" data-id="element-245">
                <div className="w-11 h-11 rounded-xl bg-brand-accent/15 flex items-center justify-center flex-shrink-0" data-id="element-246">
                  <MapPinIcon className="w-5 h-5 text-brand-accent" data-id="element-247" />
                </div>
                <div data-id="element-248">
                  <p className="font-heading uppercase tracking-wide text-xs font-bold text-gray-500" data-id="element-249">
                    Shop location
                  </p>
                  <p className="font-bold text-brand-dark" data-id="element-250">270 E 8th St.</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}